import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-101" data-mp="1hdumue42kv7m">
      <div className="max-w-3xl mx-auto" data-id="element-102" data-mp="1cf05lglr3epm">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold text-navy text-center mb-16" data-id="element-103" data-mp="1cg1izrq8odai">
          Frequently Asked Questions
        </h2>
        <div className="divide-y divide-line border-y border-line" data-id="element-104" data-mp="253f853np44k2">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.q} data-id="element-105" data-mp="1v3y3mpk6jwpo" data-mpi={index}>
                <button type="button" className="w-full py-5 text-left flex items-center justify-between gap-6 focus:outline-none focus-visible:ring-2 focus-visible:ring-seafoam rounded" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} data-id="element-106" data-mp="1v4pvpqekjcb7">
                  <span className="font-bold text-lg text-navy" data-id="element-107" data-mp="1pm1sxtv6dul6">{faq.q}</span>
                  <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-[transform,background-color] duration-200 ease-out ${open ? 'rotate-45 bg-forest text-white' : 'bg-seafoam-light text-forest'}`} aria-hidden="true" data-id="element-108" data-mp="1aoixk8nzsj4r">
                    <Plus size={18} data-id="element-109" data-mp="16pihgxwwfulg" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-110" data-mp="s0dtf03faw5f">
                  {open && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-111" data-mp="wxclld3j0t0z">
                      <div className="pb-5 pr-14 text-muted space-y-2" data-id="element-112" data-mp="2kvn4sig5qxtf">
                        {faq.a.map(p => <p key={p} data-id="element-113" data-mp="2fxlpm8lurin8">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}